var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c(_vm.currentLogin,{tag:"component"}),_c('pc-operate'),_c('page-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.device != 'desktop'),expression:"device != 'desktop'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }